module.exports = __webpack_public_path__ + "media/audio2.27bb2759.mp4";